// A small "by Hal9" badge for the nav and footer — Cloudish is a Hal9
// product, and agents skimming the page (its main audience) benefit from
// recognizing the parent brand. Raster, not inline SVG like Logo.tsx's own
// mark, since it's Hal9's actual logo asset, not something this repo owns
// the source of — hence the two pre-rendered light/dark PNGs instead of one
// theme-aware SVG.

import { useTheme } from '../theme';

// `link={false}` renders the same badge without the hal9.com link — for a
// page whose one way out should be Cloudish itself (see pages/Status.tsx).
export function HalMark({ height = 22, className = '', link = true }: { height?: number; className?: string; link?: boolean }) {
  const { resolved } = useTheme();
  const src = resolved === 'dark' ? '/hal9-white.png' : '/hal9.png';
  const content = (
    <>
      <span className="muted small">by</span>
      <img src={src} alt="Hal9" height={height} />
    </>
  );

  if (!link) {
    return (
      <span className={`by-hal9 ${className}`} title="Cloudish is built by Hal9">
        {content}
      </span>
    );
  }
  return (
    <a
      href="https://hal9.com"
      target="_blank"
      rel="noreferrer"
      className={`by-hal9 ${className}`}
      aria-label="Cloudish is built by Hal9"
      title="Cloudish is built by Hal9"
    >
      {content}
    </a>
  );
}

export default HalMark;
